import * as React from "react";
import { Menu } from "@headlessui/react";
import { Link } from "react-router-dom";
import { useStateContext } from "context/ContextProvider.jsx";
import ModalHorizon from "components/modal";
import axiosClient from "axios-client.js";
import ProfileIcon from "components/icons/ProfileIcon";
import LogoutIcon from "components/icons/LogoutIcon";

import { useNavigate, useLocation } from "react-router-dom";

export default function UserDropdown({ name }) {
    const navigate = useNavigate();

    const { user, setUser, setToken, clearAnalyticsData } = useStateContext();

    const [modal, setModal] = React.useState(false);
    function toggleModal() {
        setModal(!modal);
    }

    function logout() {
        axiosClient
            .get("/auth/logout")
            .then(({ data }) => {
                setUser(null);
                setToken(null, false);

                clearAnalyticsData();

                navigate("/auth/sign-in", {
                    replace: true,
                });
            })
            .catch((err) => {
                const response = err.response;
                if (response) {
                    console.log(response.data.message);
                }
            });
    }
    return (
        <div className="flex-2 z-[50] h-full content-center items-center self-center rounded-full px-2 hover:bg-lightPrimary dark:text-brand-500">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button className="text-md inline-flex w-full items-center justify-center rounded-full font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 dark:text-gray-500">
                        <p
                            style={{
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                            }}
                        >
                            {user?.name}
                        </p>

                        <img
                            src="/icon/chevron-down.svg"
                            alt="Profilo Utente"
                            className="self-center pb-1 text-[26px] font-bold uppercase text-navy-700 ps-2 dark:text-white"
                        />
                    </Menu.Button>
                </div>
                <Menu.Items className="ring-black/5 absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-brand-100 focus:outline-none">
                    <div className="">
                        <Menu.Item>
                            {({ active }) => (
                                <Link
                                    key={"change-password"}
                                    to={"/my/change-password"}
                                    className={`${
                                        active
                                            ? "bg-blue-500 text-white"
                                            : "text-brand-500"
                                    } group flex w-full items-center justify-between rounded-t-md px-3 py-3 text-sm`}
                                >
                                    {"PROFILO"}
                                    <ProfileIcon />
                                </Link>
                            )}
                        </Menu.Item>
                    </div>
                    <div className="">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    className={`${
                                        active
                                            ? "bg-red-600 text-white"
                                            : "text-link-red"
                                    } group flex w-full items-center justify-between rounded-b-md px-3 py-3 text-sm`}
                                    onClick={() => {
                                        toggleModal();
                                    }}
                                >
                                    {"LOGOUT"}
                                    <LogoutIcon />
                                </button>
                            )}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </Menu>

            <ModalHorizon
                title="Logout"
                description="Confermi di voler procedere al logout?"
                isOpen={modal}
                onClose={toggleModal}
                btnVisible={true}
                onClickBtn={logout}
                btnLabel="Confermo"
            ></ModalHorizon>
        </div>
    );
}
